/*
 *  Author: DL
 *  Date: 2020-12-04 14:42:51
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-17 14:35:15
 *  LastEditors: DL
 *  Description: 2D/3D切换
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useState, useContext, useCallback } from 'react';
import { Button, Icon } from 'ui';
import Control from '@/components/Control';
import Context from '@/hook/useFmapContext';

export default () => {
    const { fmap } = useContext(Context);
    const [viewMode, setViewMode] = useState('2D');

    const handleChangeViewMode = useCallback(() => {
        fmap.changeViewMode(viewMode === '2D' ? 'top' : '3d');
        setViewMode(viewMode === '2D' ? '3D' : '2D');
    }, [fmap, viewMode]);

    return (
        <Control>
            <Button onClick={handleChangeViewMode}>
                <Icon className={`icon${viewMode}`} />
            </Button>
        </Control>
    );
};
